import(/* webpackMode: "eager" */ "/tmp/8de2b88b407075a/app/[locale]/error.tsx");
